import React, { useState } from "react";
import { Flex, Image } from "@fluentui/react-northstar";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import {
    _api_approve_or_reject_timesheet,
    _api_externe_validation_leave,
} from "./api";

import ValidateLoader from "./components/ValidateLoader";
import ValidateSuccess from "./components/ValidateSuccess";
import ValidateError from "./components/ValidateError";
import Validate from "./components/Validate";

import ClockPng from "../../assets/illustrations/clock_leave_request.svg";
import { ImageClock, Wrapper } from "./style";
import useLogicManagerValidationLeaveRequest from "./hooks/useLogicManagerValidationLeaveRequest";

export const STATUS = {
    approve: "APPROVE",
    reject: "REJECT",
};

const ManagerValidationLeaveRequest = () => {
    const { query, functions, mutation, states } =
        useLogicManagerValidationLeaveRequest();

    return (
        <Wrapper vAlign="center" hAlign="center">
            <Flex styles={{ position: "relative" }}>
                <ImageClock src={ClockPng} />
                {mutation.mutate_data?.success ? (
                    <ValidateSuccess />
                ) : query.isLoading ? (
                    <ValidateLoader />
                ) : query.isError ? (
                    <ValidateError />
                ) : (
                    <Validate
                        data={query.data}
                        isLoadingMutate={mutation.isLoadingMutate}
                        status={states.status}
                        setStatus={states.setStatus}
                        _validate_or_not_request_leave={
                            functions._validate_or_not_request_leave
                        }
                    />
                )}
            </Flex>
        </Wrapper>
    );
};

export default ManagerValidationLeaveRequest;
